export default {
    appBar: {
        backgroundColor: '#FFFFFF',
        color: 'rgb(76, 117, 188)',
        fontSize: '20px'
    },
    tabBar: {
        backgroundColor: '#FFFFFF'
    },
    loader: {
        backgroundColor: 'rgb(245, 245, 245)'
    },
    toolbar: {
        height: '85px'
    },
    searchButton: {
        width: '120px'
    },
    gridList: {
      display: 'flex',
      flexWrap: 'nowrap',
      overflowX: 'auto',
    },
    gridTitleStyle: {
        color: '#FFFF'
    },
    slideContainer: {
        height: window.innerHeight - 175
    }

}



// WEBPACK FOOTER //
// ./src/Components/DashboardStyles.jsx